import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MomentumLogo from "../Assets/Images/Nowcerts.png";
import AccessDenied from "../Assets/Images/not-allowed-symbol.svg";
import Header from "../Common/Header";
import CommonValues from "../Common/Utils";
import Loader from "../CommonControls/SupportLoader";

export default function ValidateNowcerts() {
  const [loading, setLoading] = useState(false);
  const toast: any = useRef("");
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");

  useEffect(() => {
    CommonValues.ClearAllValues();
    validateNowcertsToken(token);
  }, []);

  const validateNowcertsToken = (token: any) => {
    setLoading(true);
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_AUTHAPI}/api/account/validateNowcertsToken?token=${token}`,
    };

    axios(config)
      .then((response: any) => {
        if (response.data.token == "") {
          CommonValues.Logout(navigate);
        } else {
          localStorage.setItem("SocialLogin", "true");
          localStorage.setItem("igtoken", response.data.token);
          localStorage.setItem("tenantId", response.data.tenantId);
          localStorage.setItem("userName", response.data.userName);
          localStorage.setItem("RoleId", response.data.roleId);
          localStorage.setItem("AvatarName", response.data.avatarName);
          localStorage.setItem(
            "UserName",
            response.data.firstName + " " + response.data.lastName
          );
          navigate("/upload");
        }
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          }
        } else {
          toast.current.show({
            severity: "error",
            detail: "Unknown error while getting details!",
            life: 3000,
          });
        }
      });
  };
  return (
    <div className="support-login-page">
      <Header />
      <div className="content-wrapper container-fluid  d-flex justify-content-center">
        <div className=" main-content d-flex align-items-center ">
          <div className="row login-box mx-auto ">
            <div className="col-12 text-center ">
              <div
                className=" authenticating-block text-center"
                style={{ minHeight: "200px" }}
              >
                {loading ? (
                  <>
                    <img
                      src={MomentumLogo}
                      height="50px"
                    />
                    <div className="mt-3 ">
                      <h4 className="">Authenticating</h4>
                    </div>
                    <div className="d-flex justify-content-center nowcerts-sso-loader">
                      <Loader />
                    </div>
                  </>
                ) : (
                  <>
                    <img
                      src={AccessDenied}
                      height={35}
                      width={35}
                    />
                    <p className="not-authorize-text">
                      <b>You are not authorized</b>
                    </p>
                    <p className="d-block">
                      It seems like you don't have permission to use this
                      portal.
                      <br /> Please sign in with a different account.{" "}
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
